import { useEffect } from 'react';

import { prokeyApi } from 'api/prokey';
import { useLogout } from 'components/useLogout';

export const useInactiveTimeout = () => {
  const logout = useLogout();

  useEffect(() => {
    let attempts = 0;

    const check = () => {
      prokeyApi
        .activeCheck()
        .then( (response) => {
          // all good in the neighorhood
          attempts = 0;
        })
        .catch( (error) => {
          if(attempts+1 >= 3) {
            attempts = 0;
            logout();
          } else {
            attempts += 1;
          }
        })
    }

    const timer = setInterval(check, 20000);

    return () => {
      clearInterval(timer);
    };
  }, []); // empty dependency = called only once at startup
}